import * as React from "react";
import protectedRoute from "./protectedRoute";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import HomeBar from "./HomeBar";
import Footer from "./Footer";
import {
  CssBoldDataJacketHomeTypography,
  CssBoldDataJacketHomeBodyTypography,
  CssDataJacketBodyTypography,
  CssBoldDataJacketBodyTypography,
  CssDataJacketHomePageButton,
  CssBoldDataJacketFooterTypography,
} from "./styles/styled";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import Grow from "@mui/material/Grow";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { Auth, Hub } from "aws-amplify";
import datauniverseImg from "./images/datauniverse.png";
import {
  announce,
  getFullDataJacketList,
  getNumberOfDataTables,
  getNumberOfDataRecords,
} from "./js/queriesHandling";
import { useNavigate } from "react-router";

import Odometer from "react-odometerjs";
import "./styles/odometer-theme-default.css";

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  margin: "0",
  padding: "0",
  textTransform: "none",
  fontSize: "16px",
  color: "white",
  fontWeight: "600",
  whiteSpace: "nowrap",
  "&:hover": {
    color: "#26890D",
    backgroundColor: "transparent",
  },
});

const CssDotBox = styled(Box)({
  height: "35px",
  width: "35px",
  backgroundColor: "#ffffff",
  borderRadius: "50%",
  display: "inline-block",
});

const CssHalfCircleBox = styled(Box)({
  width: "250px",
  height: "250px",
  border: "solid 3px #000",
  borderColor: "transparent transparent #ffffff #ffffff",
  borderRadius: "0px 0px 0px 400px",
  transform: "rotate(225deg)",
});

function MainHome(props) {
  const [user, setUser] = React.useState(null);
  const [announceData, setAnnounceData] = React.useState("");
  const [numOfDJ, setNumOfDJ] = React.useState(0);
  const [numOfDT, setNumOfDT] = React.useState(0);
  const [numOfDR, setNumOfDR] = React.useState(0);
  const navigate = useNavigate();

  var totalNumIds = "";

  async function checkUser() {
    try {
      const data = await Auth.currentUserPoolUser();
      const userInfo = { username: data.username };
      setUser(userInfo);
      Auth.currentSession().then().catch();
    } catch (err) {}
  }

  async function getAnnounceData() {
    setAnnounceData(await announce());
  }

  async function getAllNumberInfo() {
    try {
      const totalNum = await getFullDataJacketList();
      totalNumIds = totalNum.data_jacket_ids.split(",");
      setNumOfDJ(totalNumIds.length);
      setNumOfDT(await getNumberOfDataTables());
      setNumOfDR(await getNumberOfDataRecords());
    } catch (e) {}
  }

  function _navigateToPage(link) {
    navigate(link);
  }

  React.useEffect(() => {
    checkUser();
    Hub.listen("auth", (data) => {
      const { payload } = data;
      if (payload.event === "signOut") {
        setUser(null);
      }
    });
  }, []);

  React.useEffect(() => {
    getAllNumberInfo();
    getAnnounceData();
  }, []);

  if (user) {
    return (
      <React.Fragment>
        <HomeBar />
        <Container
          style={{
            backgroundColor: "#303234",
            position: "relative",
            overflow: "hidden",
            height: "80vh",
            minWidth: "1200px",
          }}
          maxWidth={false}
        >
          <img
            alt="メインバックグラウンド"
            src={datauniverseImg}
            style={{
              position: "relative",
              width: "auto",
              height: "800px",
              zIndex: 1,
              top: "-20px",
              opacity: "0.3",
              borderRadius: "50%",
            }}
          />
          <Grow
            in={true}
            style={{ transformOrigin: "0 0 0" }}
            {...{ timeout: 800 }}
          >
            <img
              alt="メインテーマ"
              src={datauniverseImg}
              style={{
                position: "absolute",
                width: "400px",
                height: "auto",
                left: "120px",
                top: "20px",
                zIndex: 10,
                borderRadius: "50%",
                backdropFilter: "blur(3px)",
              }}
            />
          </Grow>
          <Box
            style={{
              position: "absolute",
              display: "flex",
              width: "100vw",
              zIndex: 1,
              left: "480px",
              top: "50px",
              justifyContent: "left",
            }}
          >
            <CssDotBox style={{ marginTop: "50px", marginLeft: "32px" }} />
            <CssDotBox style={{ marginTop: "150px", marginLeft: "-12px" }} />
            <CssDotBox style={{ marginTop: "250px", marginLeft: "-56px" }} />
            <Slide
              direction="right"
              in={true}
              timeout={800}
              mountOnEnter
              unmountOnExit
            >
              <Box
                style={{
                  float: "left",
                  marginTop: "-15px",
                  width: "400px",
                  height: "80px",
                  borderBottom: "solid 1.25px white",
                }}
              >
                <CssBoldDataJacketBodyTypography
                  style={{
                    marginLeft: "32px",
                    marginTop: "0",
                    paddingTop: "0",
                    paddingBottom: "4px",
                    fontWeight: "normal",
                    fontSize: "18px",
                  }}
                >
                  Total Data Jackets
                </CssBoldDataJacketBodyTypography>
                <CssBoldDataJacketBodyTypography
                  style={{
                    marginLeft: "48px",
                    marginTop: "4px",
                    paddingTop: "0",
                    fontSize: "32px",
                  }}
                >
                  <Odometer
                    value={numOfDJ}
                    duration={3000}
                    format="(,ddd),dd"
                  />{" "}
                  Jackets
                </CssBoldDataJacketBodyTypography>
              </Box>
            </Slide>
            <Slide
              direction="right"
              in={true}
              timeout={800}
              mountOnEnter
              unmountOnExit
            >
              <Box
                style={{
                  float: "left",
                  marginTop: "85px",
                  marginLeft: "-390px",
                  width: "450px",
                  height: "80px",
                  borderBottom: "solid 1.25px white",
                }}
              >
                <CssBoldDataJacketBodyTypography
                  style={{
                    marginLeft: "64px",
                    marginTop: "0",
                    paddingTop: "0",
                    paddingBottom: "4px",
                    fontWeight: "normal",
                    fontSize: "18px",
                  }}
                >
                  Total Data Tables
                </CssBoldDataJacketBodyTypography>
                <CssBoldDataJacketBodyTypography
                  style={{
                    marginLeft: "76px",
                    marginTop: "4px",
                    paddingTop: "0",
                    fontSize: "32px",
                  }}
                >
                  <Odometer
                    value={numOfDT}
                    duration={3000}
                    format="(,ddd),dd"
                  />{" "}
                  Tables
                </CssBoldDataJacketBodyTypography>
              </Box>
            </Slide>
            <Slide
              direction="right"
              in={true}
              timeout={800}
              mountOnEnter
              unmountOnExit
            >
              <Box
                style={{
                  float: "left",
                  marginTop: "185px",
                  marginLeft: "-465px",
                  width: "400px",
                  height: "80px",
                  borderBottom: "solid 1.25px white",
                }}
              >
                <CssBoldDataJacketBodyTypography
                  style={{
                    marginLeft: "36px",
                    marginTop: "0",
                    paddingTop: "0",
                    paddingBottom: "4px",
                    fontWeight: "normal",
                    fontSize: "18px",
                  }}
                >
                  Total Data Records
                </CssBoldDataJacketBodyTypography>
                <CssBoldDataJacketBodyTypography
                  style={{
                    marginLeft: "48px",
                    marginTop: "4px",
                    paddingTop: "0",
                    fontSize: "32px",
                  }}
                >
                  <Odometer
                    value={numOfDR}
                    duration={3000}
                    format="(,ddd),dd"
                  />{" "}
                  Records
                </CssBoldDataJacketBodyTypography>
              </Box>
            </Slide>
          </Box>
          <Box
            style={{
              position: "absolute",
              display: "flex",
              width: "100vw",
              zIndex: 1,
              left: "350px",
              top: "90px",
              justifyContent: "left",
            }}
          >
            <CssHalfCircleBox />
          </Box>
          <CssBoldDataJacketHomeTypography
            src={datauniverseImg}
            style={{
              position: "absolute",
              width: "auto",
              zIndex: 1,
              right: 0,
              top: "30px",
              opacity: "0.3",
              borderRadius: "50%",
            }}
          >
            DATAUNIVERSE
          </CssBoldDataJacketHomeTypography>
          <CssBoldDataJacketHomeBodyTypography
            style={{
              position: "absolute",
              width: "auto",
              zIndex: 1,
              right: 0,
              top: "100px",
              opacity: "0.3",
              borderRadius: "50%",
            }}
          >
            DATAUNIVERSE supports the execution of <br />
            dX and realizes collaboration from data
          </CssBoldDataJacketHomeBodyTypography>
          <Fade in={true} timeout={1200}>
            <Box
              style={{
                position: "absolute",
                display: "flex",
                width: "100vw",
                zIndex: 1,
                left: "0",
                top: "430px",
                justifyContent: "center",
                minWidth: "1200px",
              }}
            >
              <CssDataJacketHomePageButton
                style={{
                  display: "flex",
                  flexDirection: "column ",
                  textAlign: "center",
                  marginRight: "10px",
                }}
                onClick={() => {
                  _navigateToPage("/datalist");
                }}
              >
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                >
                  検索画面から探す
                </Typography>
                <span style={{ height: "15px" }}></span>
                <Typography
                  style={{
                    fontSize: "12px",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                >
                  キーワード検索やお気に入り検索ができます
                </Typography>
              </CssDataJacketHomePageButton>
              <CssDataJacketHomePageButton
                style={{
                  display: "flex",
                  flexDirection: "column ",
                  textAlign: "center",
                  padding: "0",
                  marginLeft: "10vw",
                }}
                onClick={() => {
                  _navigateToPage("/graph");
                }}
              >
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                >
                  CONNECT DJから探す
                </Typography>
                <span style={{ height: "15px" }}></span>
                <Typography
                  style={{
                    fontSize: "12px",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                >
                  関連するデータジャケットを探索できます
                </Typography>
              </CssDataJacketHomePageButton>
            </Box>
          </Fade>
          <Fade in={true} timeout={1200}>
            <Stack
              direction="column"
              justifyContent="left"
              alignItems="left"
              spacing={2}
              style={{
                position: "absolute",
                display: "flex",
                width: "80vw",
                zIndex: 1,
                left: "10vw",
                top: "530px",
              }}
            >
              <CssBoldDataJacketFooterTypography>
                The Latest
              </CssBoldDataJacketFooterTypography>
              <Box
                style={{
                  height: "100px",
                  width: "100%",
                  overflow: "auto",
                  backgroundColor: "#53565A",
                  minWidth: "1100px",
                }}
              >
                <CssDataJacketBodyTypography>
                  {announceData}
                </CssDataJacketBodyTypography>
              </Box>
            </Stack>
          </Fade>
          <Fade in={true} timeout={1200}>
            <Box
              style={{
                position: "absolute",
                display: "flex",
                width: "80vw",
                zIndex: 1,
                left: "10vw",
                top: "710px",
                marginRight: "10vw",
                color: "white",
              }}
            >
              <Grid>
                <BootstrapButton
                  onClick={() => {
                    _navigateToPage("/Manual");
                  }}
                  style={{
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                >
                  Online Manual
                </BootstrapButton>
              </Grid>
            </Box>
          </Fade>
        </Container>
        <Footer />
      </React.Fragment>
    );
  }
}

export default protectedRoute(MainHome);
